module.exports = __webpack_public_path__ + "static/assets/51b13a62d6d738aa73dc275e968af83b.png";